import { RouterProvider } from "react-router-dom";
import { observer } from "mobx-react-lite";

import router from "./routes/router";
import IntlWrapper from "./components/translations";
import {appStore, AppStoreContext} from "./store/app-store.ts";
import DebugPanel from "./components/debug-panel.tsx";

const App = observer(function App() {
  return (
    <AppStoreContext.Provider value={appStore}>
      <IntlWrapper>
        <RouterProvider router={router} />
        <DebugPanel />
      </IntlWrapper>
    </AppStoreContext.Provider>
  );
});

export default App;
